import { registerComponents } from './app/register-components.js';
import { bootstrap } from './app/bootstrap.js';

registerComponents();
bootstrap();
